import React, { useState } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "../Components/Header";
import NavBar from "../Components/NavBar";
import useAuth from "../useAuth";
import { FaArrowRight } from "react-icons/fa";
import { IoIosArrowDroprightCircle } from "react-icons/io";

export default function EntryPage() {
  const { user, menuOpen, changeMenuSize } = useAuth();
  const location = useLocation();
  const pathname = location.pathname.split("/")[2];

  if (!user) {
    return <Navigate to="/login" />;
  }
  return (
    <div className="min-h-screen flex">
      <div
        className={` ${menuOpen ? "w-72" : "w-24"
          } z-50 transition-all duration-700 fixed top-0`}
      >
        <div className="h-screen bg-white border-r border-gray-200 relative">
          <div className="h-full overflow-y-hidden">
            <NavBar />
          </div>

          <div className="absolute top-4 -right-3 z-[60]">
            <IoIosArrowDroprightCircle
              className={`text-blue-600 text-2xl bg-white rounded-full shadow-md cursor-pointer transition-transform duration-300 border border-gray-100 hover:scale-110 ${menuOpen ? "rotate-180" : "rotate-0"
                }`}
              onClick={changeMenuSize}
            />
          </div>
        </div>
      </div>

      <div
        className={`${menuOpen ? "ml-72" : "ml-24"
          } transition-all duration-700 w-full bg-slate-300`}
      >
        <div className="sticky z-30 top-0">
          <Header />
        </div>
        <div className="p-4 min-h-screen z-10 bg-gradient-to-b from-gray-50 to-gray-100 text-gray-800">
          {<Outlet />}
        </div>
        {pathname !== "grievancesMsgs" && (
          <div className="px-4 py-4 border-t-[0.1px] text-xs text-slate-900 mx-4 border-gray-400">
            COPYRIGHT - BRAVISHMAH INFOTECH PRIVATE LIMITED
          </div>
        )}
      </div>
    </div>
  );
}
